import { TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { PrintablePlayerSortName } from '@sorare/core/src/contexts/config';

import { commonCardsGridFragment } from '@sorare/marketplace/src/components/commonCard/CommonCardsGrid/types';
import { PaginatedCommonCardsGrid } from '@sorare/marketplace/src/components/commonCard/PaginatedCommonCardsGrid';
import { usePrintablePlayersSearchClient } from '@sorare/marketplace/src/hooks/search/usePrintablePlayersSearchClient';
import { commonCardsFilters } from '@sorare/marketplace/src/searchCards/nba/cardFilters';

import { NBACardSearch } from 'components/searchCards/NBACardSearch';

import {
  NBAPrintablePlayersSearchQuery,
  NBAPrintablePlayersSearchQueryVariables,
} from './__generated__/page.graphql';

const sorts: PrintablePlayerSortName[] = [
  'DESC-L10',
  'ASC-name_for_sorting',
  'DESC-name_for_sorting',
];

const PRINTABLE_PLAYERS_SEARCH_QUERY = gql`
  query NBAPrintablePlayersSearchQuery(
    $query: String!
    $page: Int
    $pageSize: Int
    $advancedFilters: String
    $sorts: [SearchSortInput!]!
    $refinements: [SearchRefinementInput!]!
    $facets: [SearchFacetDefinitionInput!]!
    $onlyFollowed: Boolean
  ) {
    searchPlayers(
      query: $query
      page: $page
      pageSize: $pageSize
      sorts: $sorts
      advancedFilters: $advancedFilters
      refinements: $refinements
      facets: $facets
      onlyFollowed: $onlyFollowed
    ) {
      ...usePrintablePlayersSearchClient_searchPrintablePlayers
      hits {
        id
        ...CommonCardsGrid_composeTeamBenchObjectInterface
      }
    }
  }
  ${usePrintablePlayersSearchClient.fragments.searchPrintablePlayers}
  ${commonCardsGridFragment}
` as TypedDocumentNode<
  NBAPrintablePlayersSearchQuery,
  NBAPrintablePlayersSearchQueryVariables
>;

const cardFilters = commonCardsFilters(false);

type Query = typeof PRINTABLE_PLAYERS_SEARCH_QUERY;

const AddCardPage = () => {
  const [onlyFollowed, setOnlyFollowed] = useState(false);
  const searchClient = usePrintablePlayersSearchClient<Query>(
    PRINTABLE_PLAYERS_SEARCH_QUERY,
    {
      onlyFollowed,
    }
  );

  return (
    <FullWidthContainer>
      <NBACardSearch
        sorts={sorts}
        analyticsTags={['NBA', 'Swap']}
        cardFilters={cardFilters}
        attributesToRetrieve={['slug']}
        hideOwner
        GridComponent={PaginatedCommonCardsGrid}
        defaultHitsPerPage={40}
        hideSavedFilters
        alwaysShowFavoriteButton={false}
        selectionMode="drop"
        searchClient={searchClient}
        onFavoriteFilterChange={setOnlyFollowed}
      />
    </FullWidthContainer>
  );
};

export default AddCardPage;
